import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "alert-subtitle" }, "Wijzigingen zijn niet meer mogelijk om de voortgang van het bouwproces te waarborgen.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "alert-subtitle" }, "Neem zo spoedig mogelijk contact op met Hofzicht Makelaars via telefoonnummer 0252 - 530119.", -1)

import { computed } from 'vue'
import { authStore } from '@/stores/auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononPhaseStateMessages',
  props: {
    phaseState: null,
    orderReceived: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { phaseState:string, orderReceived:boolean };



const showTestPhaseAlert = computed(() => props.phaseState === 'test' && !authStore().isInternalDemoAccount)
const showDemoPhaseAlert = computed(() => props.phaseState === 'demo' || authStore().isDemoCustomer)
const showOrderReceivedAlert = computed(() => props.phaseState === 'closed' && props.orderReceived && !authStore().isDemoCustomer)
const showOrderNotReceivedAlert = computed(() => props.phaseState === 'closed' && !props.orderReceived && !authStore().isDemoCustomer)
const alertShown = computed(() => showTestPhaseAlert.value || showDemoPhaseAlert.value || showOrderReceivedAlert.value || showOrderNotReceivedAlert.value)

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    gutter: [16,16],
    class: _normalizeClass(!_unref(alertShown) ? 'no-mb' : '')
  }, {
    default: _withCtx(() => [
      (_unref(showTestPhaseAlert))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "warning",
                message: "Er zijn voor deze fase (nog) geen opties beschikbaar. Deze worden op een later moment zichtbaar.",
                banner: ""
              })
            ]),
            _: 1
          }))
        : (_unref(showDemoPhaseAlert))
          ? (_openBlock(), _createBlock(_component_a_col, {
              key: 1,
              span: 24
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_alert, {
                  type: "warning",
                  message: "U bevindt zich in de demo-omgeving, hierdoor kunt u (nog) geen definitieve bestelling plaatsen voor deze fase.",
                  banner: ""
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
      (_unref(showOrderReceivedAlert))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 2,
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "success",
                banner: ""
              }, {
                message: _withCtx(() => [
                  _createTextVNode(" Uw bestelling voor deze fase is ontvangen."),
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_unref(showOrderNotReceivedAlert))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 3,
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "error",
                banner: ""
              }, {
                message: _withCtx(() => [
                  _createTextVNode(" Deze fase is gesloten, maar wij hebben geen bestelling ontvangen!"),
                  _hoisted_3,
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})